import { Auth } from 'aws-amplify';
import React from 'react';
import { CognitoUser } from 'amazon-cognito-identity-js';
import history from '../history';
import { TrackEvent } from '../utils/AnalyticsUtils';
import UsersClient from '../clients/UsersClient';
import { PortalConfigContext } from '../context';
import StringUtils from '../utils/StringUtils';
import { SIGNED_IN_WITH_GOOGLE_USER_KEY } from '../constants/authConsts';
import { logoutFromHostedUi } from '../utils/AuthUtils';

export const useLogout = () => {
  const portalConfig = React.useContext(PortalConfigContext);

  const logout = async (
    isTestUser: boolean,
    redirectUrl: string,
    isClient: boolean,
    allSessions = true,
  ) => {
    const currentUser: CognitoUser = await Auth.currentAuthenticatedUser();
    const googleSignedInUser = window.localStorage.getItem(
      SIGNED_IN_WITH_GOOGLE_USER_KEY,
    );

    // if we are logging out a user, who was logged in through google
    // then we should clear the storage item for this user
    // this allows us to skip calling the hosted ui endpoint for the non federated users
    if (currentUser.getUsername() === googleSignedInUser) {
      window.localStorage.removeItem(SIGNED_IN_WITH_GOOGLE_USER_KEY);
    }

    await Auth.signOut();

    TrackEvent(`Signed Out`, { isTestUser });
    // clients should be redirected to the SignoutRedirectURL internal users have set,
    // whether that is within copilot domain or a marketing site of their choice
    if (isClient) {
      window.location.replace(`/auth/signout?next=${redirectUrl}`);
    } else {
      const endFc = allSessions
        ? UsersClient.endSessions
        : UsersClient.endCurrentSession;
      await endFc();

      // if there was a google sign in done, and we are trying to log out of all sessions
      // we need to call the hosted ui logout endpoint, to complete the login
      // this ensures that the next time, we try logging in with google an account selection
      // screen is shown
      if (
        allSessions &&
        googleSignedInUser &&
        !StringUtils.isEmptyString(googleSignedInUser)
      ) {
        // since all the user logged in with google will be signed out, we clear the
        // storage
        window.localStorage.removeItem(SIGNED_IN_WITH_GOOGLE_USER_KEY);

        // logs any google authed user out
        logoutFromHostedUi(portalConfig, window.location.origin + redirectUrl);
      }

      history.replace(redirectUrl);
    }
  };
  return logout;
};
